module.exports = __webpack_public_path__ + "img/arrow-down.6569ddde.svg";